import { footer } from "./footer/footer";
import { navbar } from "./navbar/navbar";
export var _navigate = {
    footer: function (args) { return footer(args); },
    navbar: function (args) { return navbar(args); }
};
